import { BehaviorContext } from '../../behavior-context';
import { Behavior } from '../../behavior';
import { PgPalette } from '../../../ui/palette';
import { Injectable } from '@angular/core';

@Injectable()
export class TemplateShowNotificationBehavior implements Behavior {
  async execute(
    args: {
      title: string;
      body: string;
      collapseAction: 'collapse' | 'dismiss';
      color: PgPalette;
      bold: boolean;
      duration: number;
    },
    context: BehaviorContext
  ): Promise<any> {
    const template = context.get('template') as any;
    return template.showPageNotification(
      args.title,
      args.body,
      null,
      args.collapseAction || 'collapse',
      args.color || 'info',
      args.bold || false,
      args.duration || 0
    );
  }
}
